import { render, staticRenderFns } from "./siteStandardization.vue?vue&type=template&id=2d235815&scoped=true&"
import script from "./siteStandardization.vue?vue&type=script&lang=js&"
export * from "./siteStandardization.vue?vue&type=script&lang=js&"
import style0 from "./siteStandardization.vue?vue&type=style&index=0&id=2d235815&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d235815",
  null
  
)

export default component.exports